module.exports = __webpack_public_path__ + "img/smartcams.5e5898ba.png";